import React, { useEffect, useRef } from "react";
import { Container, Table, Button, Spinner, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchPatientsByUser } from "../../redux/slices/PatientSlice";
import { useNavigate } from "react-router-dom";
import NavbarComponent from "./SenseNavBar";
import Footer from "./Footer";

function PatientList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const patients = useSelector((state) => state.patients.patients);
  const loading = useSelector((state) => state.patients.loading);
  const initialized = useRef(false);

  useEffect(() => {
    if (user) {
      dispatch(fetchPatientsByUser(user.user_id));
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (patients.length > 0 && !initialized.current) {
      initialized.current = true;
    }
  }, [patients]);

  const handleViewDashboard = (patient_id) => {
    navigate(`/dashboard/${patient_id}`);
  };

  // Show spinner on first load only
  if (!initialized.current && loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div className="dashboard-wrapper">
      <NavbarComponent />
      <Container
        fluid
        className="dashboard-content"
        style={{ minHeight: "60vh", paddingTop: "20px" }}
      >
        <Row className="justify-content-center mb-3">
          <Col md={10} lg={8}>
            <h2 className="text-center mb-4" style={{ fontWeight: "bold" }}>
              Patients Assigned to You
            </h2>
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th className="text-center">Patient ID</th>
                    <th className="text-center">Patient Name</th>
                    <th className="text-center">Gender</th>
                    <th className="text-center">Age</th>
                    <th className="text-center">View Dashboard</th>
                  </tr>
                </thead>
                <tbody>
                  {patients.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No patients assigned.
                      </td>
                    </tr>
                  ) : (
                    patients.map((patient) => (
                      <tr key={patient.patient_id}>
                        <td className="text-center">{patient.patient_id}</td>
                        <td className="text-center">{patient.patient_name}</td>
                        <td className="text-center">{patient.gender}</td>
                        <td className="text-center">{patient.age}</td>
                        <td className="text-center">
                          <Button
                            variant="primary"
                            onClick={() =>
                              handleViewDashboard(patient.patient_id)
                            }
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default PatientList;
